import serviceProject from "../serviceProject";
import { PredecessorsAndSuccessors } from "../../../service";

let Meter = {
  ...serviceProject,
  resource: "meters"
};
Meter = { ...Meter, ...PredecessorsAndSuccessors(Meter) };
export default Meter;
